import { getErrorMessage } from 'ha/constants/ErrorMessages';

import { TranslateFunc } from '@ha/intl';
import { ResponseError } from 'ha/services/apiV2/types/ResponseError';

type Errors = { submitError?: string } & Record<string, string>;

export class SubmissionError extends Error {
  static __FLAG__ = '@@redux-form/submission-error-flag';

  errors: Errors;

  constructor(errors: Errors) {
    super('Submit Validation Failed');
    this.errors = errors;
  }
}

export function normalizeApiV2Errors(
  T: TranslateFunc,
  err: ResponseError,
): SubmissionError {
  const apiErrors =
    (err && err.cause && err.cause.response && err.cause.response.errors) ||
    null;

  if (!apiErrors) {
    return new SubmissionError({
      submitError: T(getErrorMessage(err.message)),
    });
  }

  const errors = apiErrors.reduce((acc, error) => {
    if (!error.key) {
      // eslint-disable-next-line no-underscore-dangle
      acc.submitError = T(getErrorMessage(error.detail));
    } else {
      acc[error.key] = T(getErrorMessage(error.detail));
    }

    return acc;
  }, {} as Record<string, string>);

  return new SubmissionError(errors);
}
